module.exports = __webpack_public_path__ + "static/media/green.64e804ae.png";